module.exports = __webpack_public_path__ + "img/csgologo.b2fa1434.png";